import { memo, useCallback, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  FormContainer,
  FormInput,
  Information,
  Treturn,
  useFetch,
  useNotificationContext,
} from "@4uhub/lib4uhub";
import { Grid, Typography } from "@mui/material";
import {
  TWhatsappNameForm,
  whatsappNameSchema,
} from "./WhatsappNameForm.schema";
import TicketServService from "../../../services/ticket.service";
import { IWhatsappName } from "../../../models/whatsapp-name";

const translationPath =
  "chatBot.page.register.ticketServiceWhats.whatsappNamePath.";
const ticketService = new TicketServService();

export const WhatsappNameForm = memo(({ onClose }: any) => {
  const { ticketServiceId } = useParams();
  const { t } = useTranslation();

  const [data, setData] = useState<IWhatsappName>();

  const { setMessage } = useNotificationContext();

  const { sendRequest: update, loading: uLoading } = useFetch(
    ticketService.updateWhatsappName
  );

  const {
    sendRequest: getWhatsappName,
    loading: loadingGetWhatsappBusinesProfile,
  } = useFetch(ticketService.getWhatsappName);

  const updateHandler = (v: TWhatsappNameForm, id: string) => {
    return update({
      ticketServiceId: id,
      newDisplayName: v.newDisplayName,
    });
  };

  const getHandler = useCallback(
    async (ticketServiceId: string): Promise<Treturn<TWhatsappNameForm>> => {
      const { data, success } = await getWhatsappName({
        ticketServiceId,
      });
      if (data) {
        setData(data);
        const newData: TWhatsappNameForm = {
          ...data,
        };
        return { data: newData, success: true };
      }
      return { data, success };
    },
    [getWhatsappName]
  );

  const successHandle = (data: { success: boolean }) => {
    if (data && data.success) {
      setMessage({
        message: t(translationPath + "nameUpdated"),
      });
    } else {
      setMessage({
        message: t(translationPath + "error.nameUpdated"),
        type: "error",
      });
    }
    onClose();
  };

  const loading = loadingGetWhatsappBusinesProfile || uLoading;

  return (
    <FormContainer<TWhatsappNameForm>
      updateFunction={updateHandler}
      getFunction={getHandler}
      loading={loading}
      title={t(translationPath + "whatsappNameModalTitle")}
      subtitle={""}
      backButtonOnClick={onClose}
      schema={whatsappNameSchema}
      showBackButton={false}
      onSuccess={successHandle}
      redirectOnSave={false}
      isModalForm={true}
      propId={ticketServiceId}
      marginBottom={0}
      customHeight={"fit-content"}
      formActionsOnBottom={false}
      disableSave={data?.newDisplayName != null}
      fields={(type) => (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <FormInput
              name="verifiedName"
              label={t(translationPath + "verifiedName") || "verifiedName"}
              size="small"
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <FormInput
              name="newDisplayName"
              label={t(translationPath + "newDisplayName") || "newDisplayName"}
              size="small"
              fullWidth
              disabled={data?.newDisplayName != null}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <FormInput
              name="qualityRating"
              label={t(translationPath + "qualityRating") || "qualityRating"}
              size="small"
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <FormInput
              name="messagingLimitTier"
              label={
                t(translationPath + "messagingLimitTier") ||
                "messagingLimitTier"
              }
              size="small"
              fullWidth
              disabled
            />
          </Grid>
          {data?.newDisplayName && (
            <Grid item xs={12} sm={12}>
              <Typography
                sx={{
                  marginBottom: 4,
                  color: "red",
                }}
              >
                {t(translationPath + "waiting_update")}
              </Typography>
            </Grid>
          )}
        </Grid>
      )}
    />
  );
});
